import React, { memo } from 'react';
import { AppBar, Toolbar, Grid } from '@material-ui/core';

export default memo(({ LComp, MComp, RComp }) => {
  return (
    <AppBar position='static'>
      <Toolbar disableGutters>
	<Grid container alignItems='center'>
	  <Grid item xs={2}>
	    { LComp }
	  </Grid>
	  <Grid item xs={8}>
	    { MComp }
	  </Grid>
	  <Grid item xs={2} container justify='flex-end'>
	    { RComp }
	  </Grid>
	</Grid>
      </Toolbar>
    </AppBar>
  );
});
